import { getCall } from "../../utils/apiCalls";
import { isStaging } from "../../config";
import {
  PAYOUT_LIST,
  CLEAR_PAYOUT_DATA,
  CALCULATE_CUMULATIVE_DATA,
  PAYTM_ASSURED_CLAIM_REPORT,
  CLEAR_PAYTM_ASSURED_CLAIM_REPORT,
} from "./actionTypes";
import {
  GET_PAYOUT_LIST,
  DOWNLOAD_REPORT,
  DOWNLOAD_CUMULATIVE_PAYOUT_LIST,
  GET_PAYTM_ASSURED_CLAIM_REPORT,
} from "../../config/urls";
import store from "../../store";
import { showLoader, hideLoader } from "../../containers/utility/actions";

import FileDownload from "js-file-download";

export const getPayoutList = (query) => (dispatch) => {
  getCall(GET_PAYOUT_LIST, query, ["merchant"]).then((res) => {
    if (!res.data || !res.data.length) return;
    dispatch({
      type: PAYOUT_LIST,
      payload: res.data || [],
    });
  });
};

export const getPaytmAssuredClaimReport = (query) => (dispatch) => {
  getCall(GET_PAYTM_ASSURED_CLAIM_REPORT, query, ["merchant"]).then((res) => {
    if (!res.data) {
      dispatch({
        type: PAYTM_ASSURED_CLAIM_REPORT,
        payload: "",
      });
    }
    dispatch({
      type: PAYTM_ASSURED_CLAIM_REPORT,
      payload: res.data,
    });
  });
};

export const clearPayoutData = () => ({
  type: CLEAR_PAYOUT_DATA,
});

export const clearPaytmAssuredClaimReport = () => ({
  type: CLEAR_PAYTM_ASSURED_CLAIM_REPORT,
});

export const downloadReport = (settledAt) => (dispatch) => {
  getCall(DOWNLOAD_REPORT, { settled_at: settledAt }, ["merchant"]).then(
    (res) => {
      FileDownload(res.data, `${settledAt}.csv`);
    }
  );
};

export const downloadPDF = (settledAt) => (dispatch) => {
  const token = localStorage.getItem("access-token") || "";
  let redirectUri = isStaging
    ? "https://travel-dev.paytm.com/bus-operator-dashboard/v1"
    : "https://travel.paytm.com/bus-operator-dashboard/v1";
  const apiConfigurations = [
    // {
    //   url: `${redirectUri}/bus/payout/report/pdf?settled_at=${settledAt}`,
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     access_token: token,
    //   },
    //   body: JSON.stringify({}),
    // },
    {
      url: `${redirectUri}/bus/payout/list/pdf?settled_at=${settledAt}`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        access_token: token,
      },
      body: JSON.stringify({}),
    },
  ];

  const fetchPromises = apiConfigurations.map((config) => {
    const fetchOptions = {
      method: config.method,
      headers: new Headers(config.headers),
      body: config.body,
    };
    return fetch(config.url, fetchOptions);
  });
  store.dispatch(showLoader());

  Promise.all(fetchPromises)
    .then((responses) => {
      const blobs = responses.map((response) => {
        if (!response.ok) {
          throw new Error("Failed to download PDF");
        }
        return response.blob();
      });
      return Promise.all(blobs);
    })
    .then((blobs) => {
      blobs.forEach((blob, index) => {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download =
          index === 0
            ? `Payout List(${settledAt}).pdf`
            : `Payout Summary(${settledAt}).pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
      store.dispatch(hideLoader());
    })
    .catch((error) => {
      store.dispatch(hideLoader());
      alert("Failed to download PDF");
    });
};

export const getCumulativePayoutList = (query) => (dispatch) => {
  getCall(
    `${DOWNLOAD_CUMULATIVE_PAYOUT_LIST}?settled_after=${query.settled_after}&settled_before=${query.settled_before}`,
    {},
    ["merchant"]
  ).then((res) => {
    FileDownload(
      res.data,
      `${query.settled_after} to ${query.settled_before}.csv`
    );
  });
};

export const getCumulativePayoutListPDF = (query) => (dispatch) => {
  const token = localStorage.getItem("access-token") || "";
  let redirectUri = isStaging
    ? "https://travel-dev.paytm.com/bus-operator-dashboard/v1"
    : "https://travel.paytm.com/bus-operator-dashboard/v1";
  const apiConfigurations = [
    // {
    //   url: `${redirectUri}/bus/payout/report/pdf?settled_after=${query.settled_after}&settled_before=${query.settled_before}&offset=0&limit=25`,
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     access_token: token,
    //   },
    //   body: JSON.stringify({}),
    // },
    {
      url: `${redirectUri}/bus/payout/list/pdf?settled_after=${query.settled_after}&settled_before=${query.settled_before}&offset=0&limit=25`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        access_token: token,
      },
      body: JSON.stringify({}),
    },
  ];

  const fetchPromises = apiConfigurations.map((config) => {
    const fetchOptions = {
      method: config.method,
      headers: new Headers(config.headers),
      body: config.body,
    };
    return fetch(config.url, fetchOptions);
  });
  store.dispatch(showLoader());

  Promise.all(fetchPromises)
    .then((responses) => {
      const blobs = responses.map((response) => {
        if (!response.ok) {
          throw new Error("Failed to download PDF");
        }
        return response.blob();
      });
      return Promise.all(blobs);
    })
    .then((blobs) => {
      blobs.forEach((blob, index) => {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download =
          index === 0
            ? `Payout List(${query.settled_after} - ${query.settled_before}).pdf`
            : `Payout Summary(${query.settled_after} - ${query.settled_before}).pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
      store.dispatch(hideLoader());
    })
    .catch((error) => {
      store.dispatch(hideLoader());
      alert("Failed to download PDF");
    });
};

export const calculateCumulates = (payoutList) => (dispatch) => {
  let cumulativeBookedSeats = 0;
  let cumulativeAmount = 0;
  let cumulativeCommission = 0;
  let cumulativeCancelledSeats = 0;
  let cumulativeCancelledAmount = 0;
  payoutList.map((item) => {
    cumulativeBookedSeats = cumulativeBookedSeats + item.booked_seats;
    cumulativeAmount = cumulativeAmount + item.booking_amount;
    cumulativeCommission = cumulativeCommission + item.commission;
    cumulativeCancelledSeats = cumulativeCancelledSeats + item.cancelled_seats;
    cumulativeCancelledAmount =
      cumulativeCancelledAmount + item.cancellation_amount;
  });
  const cumulativeData = {
    totalBooked: cumulativeBookedSeats,
    totalAmount: cumulativeAmount,
    totalCommission: cumulativeCommission,
    totalCancelledSeats: cumulativeCancelledSeats,
    totalCancelledAmount: cumulativeCancelledAmount,
  };
  dispatch({
    type: CALCULATE_CUMULATIVE_DATA,
    payload: cumulativeData || [],
  });
};
